var doMain = 'http://116.236.187.4:9082/de/'